import { formatCivilDate, formatInstant } from '@/i18n/format';

/** Civil `YYYY-MM-DD` or an ISO instant; unparseable values render as received. */
export function formatWhen(value: string, locale: string, timeZone: string): string {
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    try {
      return formatCivilDate(value, locale);
    } catch {
      return value;
    }
  }
  try {
    return formatInstant(value, locale, timeZone);
  } catch {
    return value;
  }
}
